import { Component, OnInit, ElementRef, Inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../services/language.service';

import { MatDialog, MatDialogRef, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { TokenStorageService } from '../../services/auth-user-service/token-storage.service';

import { DatePipe } from '@angular/common';

import { IFRUtes } from '../../utes/utes.interfaces';
import { UtesService } from '../../utes/utes.service';
import { ClientsSocisUTEsService } from '../../services/clients_socis/clientsSocisUTEs.service';

import * as moment from 'moment';

@Component({
  selector: 'dialog-utes',
  templateUrl: './dialog.component.utes.html',
  styleUrls: ['./dialog.component.utes.scss'],
  providers: [ UtesService, DatePipe, ClientsSocisUTEsService ]
})

export class DialogUtes implements OnInit {
   public showAsyncProgress: boolean = false;
   public utesData: Array<IFRUtes> = [];
   public utesSocis: Array <any> = []
   public llistaCodis: any;
   public tbCodis: any;
   public rol: any = 0;
   private op: any = 'NEW';

   public editUtesData = Object.assign({});

   private UtesModel: IFRUtes = {
      'id': 'NEW',
      'codi': null,
      'nom': null,
      'nif': null,
      'compte': null,
      'codi1': null,
      'gerent': null,
      'gestiona': null,
      'alta': null,
      'inoperativa': null,
      'baixa': null,
      'caducitat_digital': null,
      'capital_social': null,
      'percent_propi': null
   };

  public editar(i): void { this.editUtesData = this.utesData[i]; this.op = this.editUtesData.id; }

  constructor(public translate: TranslateService, public languageService: LanguageService, private tokenStorage: TokenStorageService, private utesService: UtesService, private clientsSocisUTEsService: ClientsSocisUTEsService, public dialogRef: MatDialogRef<DialogUtes>, @Inject(MAT_DIALOG_DATA) public data: any) { 
    this.editUtesData = data;
    if(!this.editUtesData.alta)this.editUtesData.alta = moment().format("YYYY-MM-DD");
  }
  
  setSocisUtes(){
    this.clientsSocisUTEsService.get(this.editUtesData.codi)
    .subscribe(
      data => {
         this.utesSocis = data },
      error => console.log(error)
    );
  }
  
  ngOnInit() {
    this.op = this.editUtesData.id;
    this.utesService.getCodis()
    .subscribe(
       codis => {
         this.tbCodis = codis; this.llistaCodis = codis;
         if(!this.editUtesData.alta)this.editUtesData.alta = moment().format("YYYY-MM-DD");
         if(!this.editUtesData.codi)return;
         this.setSocisUtes();
         this.rol = this.tokenStorage.getRol();
       },
       error => console.log(error)
    );
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  desar(): void {if(!this.editUtesData.codi){alert("El camp 'codi' és necessari");return;}this.close();
    /*this.showAsyncProgress = true;
    this.utesService.updateUtes(this.op, this.editUtesData)
      .subscribe(updatedData => {
        this.editUtesData = updatedData;
        if(this.op == 'NEW')this.utesData.unshift(Object.assign(this.editUtesData));
        this.op = 'NEW';
        this.editUtesData = Object.assign({})
        this.editUtesData.id= 'NEW';
        this.editUtesData.codi = updatedData.codi;
        this.editUtesData.alta = moment().format("YYYY-MM-DD");
        console.log("S'han desat les dades");
        this.showAsyncProgress = false;
        this.close();
      });*/
  }

  close(): void {
    this.dialogRef.close(this.editUtesData);
  }

}
